import { InputContainer } from "@/components/ui/forms/inputContainer"
import { Textarea } from "@/components/ui/baseUi/textarea"
import { type FieldValueChange } from "@/typings/formik"
import { type FieldInputProps } from "formik"

type TextAreaInputProps<T, K> = {
  label?: string
  name: string
  isRequiredInput?: boolean
  setFieldValue: FieldValueChange<K>
  getFieldProps: (nameOrOptions: T) => FieldInputProps<any>
  error?: React.JSX.Element
  className?: string
  textareaProps?: React.ComponentProps<"textarea">
  children?: React.ReactNode
} & React.ComponentProps<"div">

export function TextAreaInput<T, K>({
  label,
  name,
  isRequiredInput,
  setFieldValue,
  getFieldProps,
  error,
  className,
  textareaProps,
  children,
  ...props
}: TextAreaInputProps<T, K>) {
  const value = getFieldProps(name as T).value ?? ""

  return (
    <InputContainer
      label={label}
      name={name}
      isRequiredInput={isRequiredInput}
      error={error}
      className={className}
      {...props}
    >
      <Textarea
        id={name}
        value={value}
        className={textareaProps?.className}
        onChange={(e) => {
          setFieldValue(name, e.target.value)
        }}
        onBlur={getFieldProps(name as T)?.onBlur}
        {...{ "aria-invalid": error ? true : false }}
        {...textareaProps}
      />
      {children}
    </InputContainer>
  )
}
